import { render, staticRenderFns } from "./EntityPromotions.vue?vue&type=template&id=78f7b177&scoped=true"
import script from "./EntityPromotions.vue?vue&type=script&lang=js"
export * from "./EntityPromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f7b177",
  null
  
)

export default component.exports